import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { DialogService } from 'src/app/services/modal/dialog.service';
import { OverviewService } from 'src/app/services/overview/overview.service';
import { SidebarService } from 'src/app/services/sidebar/sidebar.service';
import { KeycloakAuthService } from 'src/app/auth/keycloak.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WorkflowService, WorkflowNotification } from 'src/app/services/workflow/workflow.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
    currentRole: any = ""
    name: string = ""
    initial: string = ''

    /** RT-22 in-app notifications */
    notifications: WorkflowNotification[] = [];
    isNotificationsOpen = false;
    private pollSub?: Subscription;
    private static readonly POLL_MS = 60_000;

    constructor(public dialogService: DialogService,
      private keycloakAuthService: KeycloakAuthService,
      private router: Router,
      public overviewService: OverviewService,
      public sidebarService: SidebarService,
      private authService: AuthService,
      private workflowService: WorkflowService
      ) {}

    isToggleOpen:boolean = false;

    get unreadCount(): number {
      return this.notifications.filter(n => !n.isRead).length;
    }

    toggleDropdown() {
      this.isToggleOpen = !this.isToggleOpen;
    }

    toggleNotifications() {
      this.isNotificationsOpen = !this.isNotificationsOpen;
      if (this.isNotificationsOpen) this.loadNotifications();
    }

    loadNotifications() {
      this.workflowService.getNotifications().subscribe({
        next: (rows) => (this.notifications = rows ?? []),
        error: () => { /* notifications are non-critical; ignore transient failures */ },
      });
    }

    openNotification(n: WorkflowNotification) {
      this.isNotificationsOpen = false;
      const goToItem = () => this.router.navigate(['/workflow-runtime/instances', n.workflowItemId]);
      if (n.isRead) { goToItem(); return; }
      this.workflowService.markNotificationRead(n.workflowNotificationId).subscribe({
        next: () => { n.isRead = true; goToItem(); },
        error: () => goToItem(),
      });
    }

    setShowLogout(status:any) {
      this.isToggleOpen = false;
      this.dialogService.showModal = true
    }

    async handleLogout() {
      this.overviewService.resetToHome()
      await this.keycloakAuthService.logout();
    }
    async ngOnInit(): Promise<void> {
      const profile = await this.keycloakAuthService.getUserProfile();
      const firstName = profile?.firstName || localStorage.getItem('firstName') || '';
      const lastName = profile?.lastName || localStorage.getItem('lastName') || '';

      this.currentRole = this.keycloakAuthService.getPrimaryRole() ?? '';
      this.name = `${firstName} ${lastName}`.trim() || this.keycloakAuthService.getUsername() || '';
      this.initial = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();

      this.loadNotifications();
      this.pollSub = interval(HeaderComponent.POLL_MS).subscribe(() => this.loadNotifications());
    }

    ngOnDestroy(): void {
      this.pollSub?.unsubscribe();
    }
}
